/**
 * Open API 키 관리 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class OpenApiKeyService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * Open API 키 목록 조회
     * 우선 다 내려주는 것으로 하고 추후 정책이 정해지면 filtering 한다.
     * @returns Open API 키 목록 조회 결과
     */
    list() {
        return this.axios.get(`/main/v1/openapi-keys`);
    }
    /**
     * Open API 키 발급
     * @returns Open API 키 발급 결과
     */
    issue(request) {
        return this.axios.post(`/main/v1/openapi-keys`, request);
    }
    /**
     * Open API 키 해제
     * @returns Open API 키 해제 결과
     */
    revoke(request) {
        return this.axios.post(`/main/v1/openapi-keys/revoke`, request);
    }
}
//# sourceMappingURL=openapikey.service.js.map